import type { ErrorMessages } from '@repo/types/messages/errors';

import { ErrorCodes } from '#errorCodes';

import { baseErrorMessages } from './baseErrorMessages';

export const userErrorMessages: ErrorMessages = {
  ...baseErrorMessages,
  [ErrorCodes.DB.VALIDATION]: {
    title: 'Użytkownik już istnieje!',
    detail: 'Użytkownik o podanym mailu już istnieje.',
  },
  [ErrorCodes.FORBIDDEN.USER.CREATE_LVL]: {
    title: 'Brak uprawnień',
    detail: 'Nie masz wystarczających uprawnień do utworzenia konta o wyższym poziomie poświadczeń.',
  },
};
